import React from 'react'

import { getActionLabel, IActionSettings, IActionType } from '@makyoapp/makyo-common'
import { Modal, RenderActionTypeIcon } from '@makyoapp/makyo-ui'

import { useActionFormContextV2 } from '@/context/ActionFormContextV2'
import { ActFormPlugin, ActionFormMap } from '@/context/ActionFormProviderV2'
import { isEmpty } from '@/shared/utils'

const LoadingPlaceholder = () => (
  <div className='space-y-4 animate-pulse'>
    <div className='p-4'>
      <div className='flex gap-6'>
        <div className='w-[25%] h-[36px] rounded-sm bg-zinc-300 dark:bg-slate-700' />
        <div className='w-full h-[36px] rounded-sm bg-zinc-300 dark:bg-slate-700' />
      </div>
    </div>
    <div className='px-4 py-2 border-t flex justify-between items-center'>
      <div className='w-[80px] h-[36px] rounded-sm bg-zinc-300 dark:bg-slate-700' />
      <div className='w-[80px] h-[36px] rounded-sm bg-zinc-300 dark:bg-slate-700' />
    </div>
  </div>
)

export function ActionFormModal({
  onSubmit,
}: {
  onSubmit: (id: string, action: IActionType, data?: IActionSettings) => void
}) {
  // access form context
  const { editedForm, setEditedForm, closeActForm, actionTriggerSource } = useActionFormContextV2()

  const isPluginAction = editedForm && editedForm.settings?.pluginAction

  const ActionFormComponent = editedForm && !isPluginAction ? ActionFormMap[editedForm.type] : null
  const Component = isPluginAction ? ActFormPlugin : ActionFormComponent

  const pluginName = isPluginAction ? editedForm?.type : getActionLabel(editedForm?.type as IActionType)
  if (editedForm && Component) {
    return (
      <React.Suspense fallback={null}>
        <Modal fix show={!!editedForm} onHide={closeActForm} closeOnClickOutside={false}>
          <Modal.Header onCloseClick={closeActForm}>
            <div className='flex items-center gap-2 py-2'>
              {isPluginAction ? (
                <img src={editedForm?.settings?.pluginAction?.icon} alt={pluginName} className='w-6 h-6' />
              ) : (
                <RenderActionTypeIcon type={editedForm?.type} className='rounded-xs' />
              )}
              <span>{pluginName}</span>
            </div>
          </Modal.Header>
          <Modal.Body noPadding className='modal-md'>
            <React.Suspense fallback={<LoadingPlaceholder />}>
              <div>
                {Component && (
                  <Component
                    onSubmit={(data) => {
                      if (!editedForm) return

                      if (!!data && !isEmpty(data)) {
                        onSubmit(editedForm.id, editedForm.type, data)
                        setEditedForm(null)
                      }
                    }}
                    onDismiss={closeActForm}
                    initialData={editedForm.settings}
                    triggerSource={actionTriggerSource}
                  />
                )}
              </div>
            </React.Suspense>
          </Modal.Body>
        </Modal>
      </React.Suspense>
    )
  }
  return null
}
